<template>
  <div v-if="max" class="progressbar">
    <div class="h-[0.3em] w-full bg-[#ededed]">
      <div
        class="h-full bg-success transition-all"
        :style="{ width: `${(value / max) * 100}%` }"
      />
    </div>
  </div>
</template>

<script>
import { integer } from "vue-types";

export default {
  name: "ProgressBar",
  props: {
    value: integer().def(1),
    max: integer().def(undefined),
  },
};
</script>

<style scoped>
.progressbar {
  position: fixed;
  top: 0;
  left: -0.2em;
  width: calc(100% + 0.5em);
  z-index: 10;
}
</style>
